import React, { useEffect, useState } from 'react';
import { ChevronRight, X } from 'lucide-react';
import { candyImg } from './wbApi';
import { wbSfx } from './wbSfx';

/* Tutorial do primeiro acesso: a bruxa explica recarga → BOOM → coleta, com uma cena animada por passo. */
const CANDIES = ['pirulito', 'abobora', 'chocolate', 'caveira', 'donut', 'bruxa'];

const Cena = ({ step }) => {
  if (step === 0) {
    return (
      <div className="flex h-40 flex-col items-center justify-center gap-2 px-2">
        <div className="wb-card flex w-full items-center justify-between px-4 py-3">
          <span className="text-[11px] font-black text-purple-100">Recarga de 100.000 moedas</span>
          <span className="rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-black text-amber-950" style={{ animation: 'wb-tut-pop 2.4s ease-in-out infinite' }}>+500 🧙</span>
        </div>
        <img src="/wb/candy_bruxa.webp" alt="" className="h-16 object-contain" style={{ animation: 'wb-bob 1.6s ease-in-out infinite' }} />
        <p className="text-[10px] font-black uppercase tracking-widest text-purple-200/80">Moedas da Bruxa acumulam na sua conta</p>
      </div>
    );
  }
  if (step === 1) {
    return (
      <div className="relative h-40">
        <img src="/wb/balloon.webp" alt="" className="absolute left-1/2 top-0 h-24 -translate-x-1/2" style={{ transformOrigin: '50% 100%', animation: 'wb-tut-grow 2.4s ease-in-out infinite' }} />
        <div className="wb-hose" style={{ bottom: 38, height: 26 }} />
        <img src="/wb/detonator.webp" alt="" className="absolute bottom-0 left-1/2 h-14 -translate-x-1/2" style={{ animation: 'wb-vibe .09s linear infinite' }} />
        <div className="wb-btn-collect pointer-events-none absolute bottom-0 right-1 w-36 py-2 text-center text-[11px]">Estourar · 500</div>
      </div>
    );
  }
  if (step === 2) {
    return (
      <div className="relative h-40 overflow-hidden">
        <img src="/wb/balloon.webp" alt="" className="absolute left-1/2 top-1 h-24 w-auto -translate-x-1/2" style={{ animation: 'wb-tut-danger .12s linear infinite', filter: 'drop-shadow(0 0 22px rgba(220,38,38,.8)) saturate(1.3)' }} />
        {CANDIES.map((k, i) => (
          <img key={k} src={candyImg(k)} alt="" className="absolute left-1/2 top-[38%] w-8" style={{ '--dx': `${-110 + i * 44}px`, '--rot': `${(i - 3) * 200}deg`, animation: `wb-tut-fly 2s ease-out ${i * 0.18}s infinite`, filter: 'drop-shadow(0 4px 6px rgba(0,0,0,.5))' }} />
        ))}
        <p className="wb-title absolute inset-x-0 bottom-1 text-center text-3xl text-orange-400" style={{ textShadow: '0 0 16px rgba(249,115,22,.8)', animation: 'wb-tut-pop 1.2s ease-in-out infinite' }}>BOOM!</p>
      </div>
    );
  }
  return (
    <div className="flex h-40 flex-col items-center justify-center gap-3">
      <img src="/wb/bag.webp" alt="" className="h-20 object-contain" style={{ animation: 'wb-bob 1.6s ease-in-out infinite' }} />
      <p className="text-[11px] font-black text-amber-200">1º 100.000 · 2º 50.000 · 3º 30.000 moedas</p>
    </div>
  );
};

const PASSOS = [
  { pose: 'idle', titulo: 'Olá, eu sou a bruxa da vila!', texto: 'Cada recarga de moedas KAKO feita aqui no site rende Moedas da Bruxa: a cada 100.000 moedas você ganha o suficiente para estourar um balão.' },
  { pose: 'press', titulo: 'Junte e toque em ESTOURAR', texto: 'Com Moedas da Bruxa suficientes, aperte o botão: eu aciono o detonador e o SEU balão explode. Sem sala, sem esperar ninguém.' },
  { pose: 'scared', titulo: 'O que vai cair?', texto: 'O balão pode sair vazio, soltar um prêmio de moedas ou ser o BALÃO DOURADO — o prêmio grande vai direto para a sua conta KAKO.' },
  { pose: 'cheer', titulo: 'Ranking dos Bruxos', texto: 'Quem mais estoura balões no evento leva prêmios fixos em moedas no encerramento. Cada balão conta, com ou sem prêmio!' },
];

export const WbTutorial = ({ onClose, onRules }) => {
  const [step, setStep] = useState(0);
  useEffect(() => { wbSfx.whoosh(); }, [step]);
  const ultimo = step === PASSOS.length - 1;
  const p = PASSOS[step];
  return (
    <div className="wb-hongbao" data-testid="wb-tutorial">
      <div className="wb-envelope !max-w-[400px]">
        <button onClick={onClose} aria-label="Pular" data-testid="wb-tutorial-skip"
          className="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-black/40 text-purple-200">
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-end gap-2">
          <img key={p.pose} src={`/wb/witch_${p.pose}.webp`} alt="" className="wb-reveal-item h-28 shrink-0 object-contain drop-shadow-[0_10px_14px_rgba(0,0,0,.6)]" data-testid="wb-tutorial-witch" data-pose={p.pose} />
          <div className="relative mb-6 flex-1 rounded-2xl border border-amber-400/40 bg-black/50 px-3 py-2" data-testid="wb-tutorial-bubble">
            <i className="absolute -left-2 bottom-3 h-4 w-4 rotate-45 border-b border-l border-amber-400/40 bg-black/50" />
            <p className="wb-title text-lg leading-tight text-orange-400" data-testid="wb-tutorial-title">{p.titulo}</p>
          </div>
        </div>
        <div key={step} className="wb-reveal-item mt-2 rounded-2xl border border-purple-500/30 bg-black/30 p-2"><Cena step={step} /></div>
        <p className="mt-3 text-[12px] leading-snug text-purple-50/90" data-testid="wb-tutorial-text">{p.texto}</p>
        <div className="mt-3 flex items-center justify-center gap-1.5" data-testid="wb-tutorial-dots">
          {PASSOS.map((_, i) => <i key={i} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-5 bg-amber-400' : 'w-1.5 bg-purple-500/50'}`} />)}
        </div>
        <button onClick={() => { if (ultimo) onClose(); else setStep(step + 1); }} className="wb-btn-collect mt-3 flex items-center justify-center gap-1" data-testid="wb-tutorial-next">
          {ultimo ? 'Bora encher o balão!' : <>Próximo <ChevronRight className="h-4 w-4" /></>}
        </button>
        {ultimo && <button onClick={() => { onClose(); onRules?.(); }} className="mt-2 w-full text-center text-[11px] font-black uppercase tracking-widest text-purple-200/80 underline-offset-2 hover:underline" data-testid="wb-tutorial-rules">Ver regras completas</button>}
      </div>
    </div>
  );
};
